import { render, staticRenderFns } from "./community_add.vue?vue&type=template&id=50fcb308&scoped=true&"
import script from "./community_add.vue?vue&type=script&lang=js&"
export * from "./community_add.vue?vue&type=script&lang=js&"
import style0 from "./community_add.vue?vue&type=style&index=0&id=50fcb308&lang=less&scoped=true&"
import style1 from "./community_add.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fcb308",
  null
  
)

export default component.exports